const { html } = window;

export default (alternativeButtonText) => `
    <div class='message-container'>
        <p>${html('kindleFulfillment.kindleTroubleResponseModal.resolution')}</p>
        <p>${html('kindleFulfillment.kindleTroubleResponseModal.useReadHtml', {option: `
            <span style='font-weight: bold'>${alternativeButtonText}</span>
        `})}</p>
        <p>${html('kindleFulfillment.kindleTroubleResponseModal.sorry')}</p>
    </div>
    <div class='button-container'>
        <button type='button' class='confirm-button button radius secondary contrast u-allCaps u-center'>${html('ok')}</button>
    </div>
`;
